module.exports = __webpack_public_path__ + "static/tw-activity-tab-history-84f94f795459fd8f8dd5e30886258e8e.jpg";